import { PropsWithChildren } from 'react';

export const Rows: React.FC<PropsWithChildren & { className?: string }> & {
  FlexGrow: React.FC<PropsWithChildren & { className?: string }>;
  FlexNone: React.FC<PropsWithChildren & { className?: string }>;
} = ({ children, className }) => <div className={`flex flex-col w-full h-full ${className}`}>{children}</div>;
Rows.FlexGrow = ({ children, className }) => <div className={`flex-1 overflow-hidden ${className}`}>{children}</div>;
Rows.FlexGrow.displayName = 'Rows.FlexGrow';
Rows.FlexNone = ({ children, className }) => <div className={`flex-none ${className}`}>{children}</div>;
Rows.FlexNone.displayName = 'Rows.FlexNone';
